/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import { useState, useEffect } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import axios, { baseURL } from "utils/api";

const columns = [
  { name: "sno", align: "center" },
  { name: "Name", align: "left" },
  { name: "Email", align: "left" },
  { name: "Due Date", align: "center" },
  { name: "Completion Date", align: "center" },
  { name: "Bonus Amount", align: "center" },
  { name: "Deduction Amount", align: "center" },
  { name: "Total Amount", align: "center" },
  { name: "Status", align: "center" },
  // { name: "Action", align: "center" },
];

const PaymentsTableData = (id) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!id) return;

    const handleDeleteClick = () => {};

    // Fetch tutor payment cycles with correct API
    axios
      .get(`/tutor-payment-cycles`, { params: { tutorId: id, limit: 100, page: 1 } })
      .then((res) => {
        console.log("Tutor Payment Cycles API Response:", res.data);
        const paymentCycles = res.data?.data || [];

        if (!paymentCycles.length) {
          setRows([]);
          return;
        }

        const formattedRows = paymentCycles.map((payment, index) => {
          // Get status color and label
          const getStatusBadge = (status) => {
            const statusConfig = {
              PENDING: { color: "warning", label: "PENDING" },
              APPROVED: { color: "info", label: "APPROVED" },
              PAID: { color: "success", label: "PAID" },
              REJECTED: { color: "error", label: "REJECTED" },
              FAILED: { color: "error", label: "FAILED" },
            };
            return statusConfig[status] || { color: "secondary", label: status || "N/A" };
          };

          const statusInfo = getStatusBadge(payment.status);

          // Get parent name from financeId
          const parentName = payment.financeId?.parentId?.fullName || "";

          // Get student names from financeId.students array
          const studentNames =
            payment.financeId?.students?.length > 0
              ? payment.financeId.students.map((s) => s.fullName).join(", ")
              : "";

          // Combine parent and student names
          const displayName =
            parentName && studentNames
              ? `${parentName} (${studentNames})`
              : parentName || studentNames || "N/A";

          // Get email from parent or first student
          const email =
            payment.financeId?.parentId?.email || payment.financeId?.students?.[0]?.email || "N/A";

          // Format dates
          const dueDate = payment.cycleEndDate
            ? new Date(payment.cycleEndDate).toLocaleDateString("en-IN")
            : "N/A";

          const completionDate = payment.paymentDate
            ? new Date(payment.paymentDate).toLocaleDateString("en-IN")
            : "N/A";

          // Calculate bonus and deduction (placeholder - update based on your business logic)
          const bonusAmount = payment.bonusAmount || 0;
          const deductionAmount = payment.deductionAmount || 0;
          const totalAmount = payment.calculatedAmount || 0;
          const finalAmount = totalAmount + bonusAmount - deductionAmount;

          return {
            sno: (
              <ArgonTypography variant="caption" fontWeight="medium" color="text">
                {index + 1}
              </ArgonTypography>
            ),
            Name: (
              <ArgonBox>
                <ArgonTypography variant="caption" fontWeight="medium" color="text">
                  {parentName || "N/A"}
                </ArgonTypography>
                {studentNames && (
                  <ArgonTypography
                    variant="caption"
                    fontWeight="regular"
                    color="secondary"
                    display="block"
                  >
                    {studentNames}
                  </ArgonTypography>
                )}
              </ArgonBox>
            ),
            Email: (
              <ArgonTypography variant="caption" fontWeight="medium" color="text">
                {email}
              </ArgonTypography>
            ),
            "Due Date": (
              <ArgonTypography variant="caption" fontWeight="medium" color="text">
                {dueDate}
              </ArgonTypography>
            ),
            "Completion Date": (
              <ArgonTypography variant="caption" fontWeight="medium" color="text">
                {completionDate}
              </ArgonTypography>
            ),
            "Bonus Amount": (
              <ArgonTypography variant="caption" fontWeight="medium" color="text">
                {bonusAmount ? `₹${bonusAmount}` : "N/A"}
              </ArgonTypography>
            ),
            "Deduction Amount": (
              <ArgonTypography variant="caption" fontWeight="medium" color="text">
                {deductionAmount ? `₹${deductionAmount}` : "N/A"}
              </ArgonTypography>
            ),
            "Total Amount": (
              <ArgonTypography variant="caption" fontWeight="bold" color="success">
                {finalAmount ? `₹${finalAmount}` : "N/A"}
              </ArgonTypography>
            ),
            Status: (
              <ArgonBadge
                variant="gradient"
                badgeContent={statusInfo.label}
                color={statusInfo.color}
                size="xs"
                container
              />
            ),
            // Action: (
            //   <ArgonBox display="flex" alignItems="center" gap={0}>
            //     {/* View Icon */}
            //     <Button
            //       variant="text"
            //       size="large"
            //       component={Link}
            //       to={`/tutor-payment-cycle/${payment._id}`}
            //       sx={{ minWidth: "12px", p: 0 }}
            //     >
            //       <VisibilityIcon color="primary" />
            //     </Button>
            //     {/* Delete icon */}
            //     <Button
            //       variant="text"
            //       size="large"
            //       sx={{ minWidth: "32px", p: 0 }}
            //       onClick={() => handleDeleteClick(payment._id)}
            //     >
            //       <DeleteIcon color="error" />
            //     </Button>
            //   </ArgonBox>
            // ),
          };
        });

        setRows(formattedRows);
      })
      .catch((err) => {
        console.error("❌ Error fetching tutor payment cycles:", err);
        setRows([]);
      });
  }, [id]);

  return { columns, rows };
};

export default PaymentsTableData;
